gsap.registerPlugin(ScrollTrigger);

const sections = document.querySelectorAll('.about-intro-slider-item');
const scrollContainer = document.querySelector('.about-intro-slider');

ScrollTrigger.create({
  trigger: scrollContainer,
  start: 'top top',    // コンテナの上端が画面上端に到達
  end: 'bottom top',   // コンテナの下端が画面上端に到達

  onUpdate: (self) => {
    // 進行度に応じてactiveな要素を決定
    const progress = self.progress;
    const totalElements = sections.length;

    // 閾値でスクロール量を調整（合計100%）
    // 0.20 + 0.20 + 0.20 + 0.40 = 1.00
    let activeIndex;
    if (progress < 0.10) {//1枚目
      activeIndex = 0;
    } else if (progress < 0.20) {//2枚目
      activeIndex = 1;
    } else if (progress < 0.30) {//3枚目
      activeIndex = 2;
    } else {//4枚目
      activeIndex = 3;
    }

    // 既にactiveな要素と同じ場合はスキップ
    if (sections[activeIndex].classList.contains('active')) {
      return;
    }

    // すべてからactiveを削除して、該当要素にactiveを追加
    sections.forEach((item) => item.classList.remove('active'));
    sections[activeIndex].classList.add('active');
  }
});


